export default "__VITE_ASSET__1155b622__"